module.exports = "/assets/0fd6ece84bc8ca8c75f6259cb1a58dfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/MH.png
// module id = 2738
// module chunks = 0